// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Everest.css";

import { EverestMail } from "./EverestAssets/EverestMailContent";
import { EverestNoteContent } from "./EverestAssets/EverestNoteContent";
import { EverestMessageContent } from "./EverestAssets/EverestMessagesContent";
// import { EverestCallContent } from "./EverestAssets/EverestCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { EverestTweetContent } from "./EverestAssets/EverestTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { EverestPhotoContent } from "./EverestAssets/EverestPhotoContent";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramApp from "../../Components/TheGramApp/TheGramApp";
import { EverestTheGramContent } from "./EverestAssets/EverestGramContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(
  () => import("../../Components/AppsMenu/AppsMenuEverest")
);
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));
// const InternetApp = lazy(
//   () => import("../../Components/InternetApps/EverestInternetApp/InternetApp")
// );
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));

function Everest() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(EverestMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return null
      // return <CallApp callContent={EverestCallContent} />;
      case "photos":
        return <Photos albums={EverestPhotoContent} />;
      case "notes":
        return <NotesApp noteContent={EverestNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={EverestTweetContent} />;
      case "mail":
        return <MailApp emails={EverestMail} />;
      case "thegram":
        return <TheGramApp content={EverestTheGramContent} notifications={0} />;
      // case "santaCam":
      // return <SantaPhotos Photos={EverestSantaCamContent} />;

      case "internet":
        return null;
      // <InternetApp
      //   headerImage={InternetBanner}
      //   bodyImage={InternetArtical}
      //   logoIcon={InternetLogo}
      //   searchBarText="Hasina Jafari Mwanga"
      //   articleTitle="Hasina Jafari Mwanga"
      //   articleDate=""
      //   author="President of Tanzania"
      //   photoCaption="via Betty images"
      //   bodyText="President of Tanzania"
      //   website=""
      // />
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Everestscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="060215" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Everest;
